/**
 * 初次渲染頁數
 * @param {頁數最大值} max_page
 * @param {目前頁數} page
 */
function renderPage(max_page, page) {
  let startPage = Math.max(1, page - 2);
  let endPage = Math.min(startPage + 4, max_page);

  if (endPage - startPage < 5 && max_page > 5) {
    startPage = endPage - 4;
  }

  let output = "";
  output += `<button type="button" data-id="pagination-prev" ${
    Number(page) === 1 ? `disabled="true"` : ``
  } 
  class="w-9 h-9 flex items-center justify-center disabled:pointer-events-none  disabled:cursor-auto">
  <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none">
    <path d="M5 1L1 5L5 9" stroke="#333333" />
</button><ul class="flex gap-2">`;

  for (let i = startPage; i <= endPage; i++) {
    if (i == page) {
      output += `<li >
      <button data-page="${i}" data-type="pagination" type="button" disabled="true"
      class="w-9 h-9 flex items-center justify-center text-sm leading-[22px] text-white bg-gray-2  hover:text-white hover:bg-gray-2 border border-gray-2 rounded-[10px] duration-300 transition-all">${i}</button>
      </li>`;
    } else {
      output += `<li>
      <button data-page="${i}" data-type="pagination" type="button"
      class="w-9 h-9 flex items-center justify-center text-sm leading-[22px] text-gray-2 bg-white hover:text-white hover:bg-gray-2 border border-gray-2 rounded-[10px] duration-300 transition-all">${i}</button>
      </li>`;
    }
  }

  output += `</ul><button type="button" data-id="pagination-next" ${
    Number(page) === max_page ? `disabled="true"` : ``
  }
class="w-9 h-9 flex items-center justify-center disabled:pointer-events-none  disabled:cursor-auto">
<svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none">
  <path d="M1 1L5 5L1 9" stroke="#333333" />
</svg>
</button>`;

  const paginationContainer = document.querySelector(
    `[data-id="pagination-container"]`
  ); // 頁數區塊容器

  paginationContainer.innerHTML = output;
}

/**
 * 渲染文章列表
 * @param {文章資料} data
 * @param {渲染設定} settings
 * imgHeight: 圖片高度
 * changePageType: 更換頁數方式,
 * contentType: 資料內容種類,
 */
function renderArticles(data, settings) {
  let output = "";
  const contentContainer = document.querySelector(
    `[data-id="content-container"]`
  ); //渲染資料區

  const dataSetting = {
    imgHeight: settings.imgHeight,
    changePageType: settings.changePageType,
    contentType: settings.contentType,
    isImgCover: settings.isImgCover,
  };
  let cardContent = (item) => {
    switch (dataSetting.contentType) {
      case "production":
        return `<a href="${item.link}" class="stretched-link">
        <h4 class="text-base tracking-2 font-medium sm:text-lg sm:leading-tight">${item.title}</h4>
        </a>
        <p class="text-sm leading-normal text-gray-4">#${item.production_catalog}</p>
   `;
      case "articles":
        return `<a class="stretched-link" href="${item.link}">
        <h4 class="text-base leading-tight tracking-2 text-gray-2 sm:text-lg sm:leading-tight">
            ${item.title}
        </h4>
      </a>
    <p class="text-xs leading-normal text-gray-4 line-clamp-2 sm:text-sm sm:leading-normal">
        ${item.preview_text}
    </p>
    <div class="flex justify-between items-center text-gray-2 text-sm leading-normal">
        <p>
            ${item.post_category}
        </p>
        <p>
            ${item.post_date}
        </p>
    </div>`;
      case "case":
        const taxonomy = window.sessionStorage.getItem("taxonomy");
        const terms = window.sessionStorage.getItem("terms");

        return `<a href="${item.link}/?taxonomy=${taxonomy}&terms=${terms}" class="stretched-link">
        <h3 class="text-lg leading-tight tracking-2 font-medium sm:text-2xl sm:leading-tight">
        ${item.title}
      </h3></a>
      <ul class="flex text-gray-4">
        <li class="whitespace-nowrap text-sm leading-normal sm:text-base">
          ${item.cases_catalog_style}｜
        </li>
        <li class="whitespace-nowrap text-sm leading-normal sm:text-base">
          ${item.cases_catalog_flooring_brand}｜
        </li>
        <li class="whitespace-nowrap text-sm leading-normal sm:text-base">
          ${item.cases_catalog_floor_type}｜
        </li>
        <li class="whitespace-nowrap text-sm leading-normal sm:text-base">
          ${item.cases_catalog_price}｜
        </li>
      </ul>`;
    }
  };

  data.forEach((item) => {
    output += `<div class="group flex flex-col ${
      dataSetting.contentType === "production" ? `items-center` : ``
    } gap-3 relative">
    <div class="overflow-hidden w-full" style="height:${
      dataSetting.imgHeight
    }px">
      <img src="${item.photo}" alt="${item.title}"
          class="w-full h-full ${
            dataSetting.isImgCover === false ? "object-contain" : "object-cover"
          }  group-hover:scale-105 duration-300 ease-in transition-all">
    </div>
    ${cardContent(item)}
  </div>`;
  });

  if (dataSetting.changePageType === "changePage") {
    contentContainer.innerHTML = output;
  } else if (dataSetting.changePageType === "viewMore") {
    contentContainer.innerHTML += output;
  }
}

/**
 * 渲染影片列表
 * @param {文章資料} data
 * @param {預覽圖片高度} imgHeight
 * @param {更換頁數方式} type
 */
function renderVideoList(data, settings) {
  let output = "";
  const contentContainer = document.querySelector(
    `[data-id="content-container"]`
  ); //渲染資料區

  const dataSetting = {
    imgHeight: settings.imgHeight,
    changePageType: settings.changePageType,
  };

  data.forEach((item) => {
    output += `<div class="group flex flex-col gap-3 relative">
    <div class="overflow-hidden relative" style="height:${dataSetting.imgHeight}px">
      <img src="${item.photo}" alt="${item.title}"
          class="w-full h-full object-cover group-hover:scale-105 duration-300 ease-in transition-all">
          <svg class="absolute bottom-3 right-3" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
  <path d="M19.791 32.4664V17.5331C19.7913 17.3463 19.8419 17.1629 19.9374 17.0024C20.0329 16.8418 20.1698 16.7098 20.3339 16.6204C20.4979 16.5309 20.683 16.4872 20.8697 16.4938C21.0564 16.5005 21.2379 16.5572 21.3952 16.6581L33.0118 24.1227C33.1589 24.2169 33.28 24.3466 33.3638 24.4999C33.4476 24.6532 33.4916 24.8251 33.4916 24.9998C33.4916 25.1745 33.4476 25.3463 33.3638 25.4996C33.28 25.6529 33.1589 25.7826 33.0118 25.8768L21.3952 33.3435C21.2379 33.4444 21.0564 33.5012 20.8697 33.5078C20.683 33.5144 20.4979 33.4707 20.3339 33.3813C20.1698 33.2918 20.0329 33.1598 19.9374 32.9993C19.8419 32.8387 19.7913 32.6554 19.791 32.4685V32.4664Z" fill="white"/>
  <path d="M2.08398 24.9997C2.08398 12.3434 12.3444 2.08301 25.0007 2.08301C37.6569 2.08301 47.9173 12.3434 47.9173 24.9997C47.9173 37.6559 37.6569 47.9163 25.0007 47.9163C12.3444 47.9163 2.08398 37.6559 2.08398 24.9997ZM25.0007 5.20801C19.7516 5.20801 14.7175 7.29319 11.0058 11.0049C7.29417 14.7165 5.20898 19.7506 5.20898 24.9997C5.20898 30.2488 7.29417 35.2828 11.0058 38.9945C14.7175 42.7062 19.7516 44.7913 25.0007 44.7913C30.2497 44.7913 35.2838 42.7062 38.9955 38.9945C42.7071 35.2828 44.7923 30.2488 44.7923 24.9997C44.7923 19.7506 42.7071 14.7165 38.9955 11.0049C35.2838 7.29319 30.2497 5.20801 25.0007 5.20801Z" fill="white"/>
</svg>
    </div>
    <h4 class="text-base leading-tight tracking-2 text-gray-2 sm:text-lg sm:leading-tight">
        <button type="button" data-id="${item.id}" data-type="videoBtn" class="stretched-link fs-sm-lg fs-sm">
            ${item.title}
        </button>
    </h4>
    <div class="flex justify-between items-center text-gray-2 text-sm leading-normal">
        <p>
            ${item.post_category}
        </p>
        <p>
            ${item.post_date}
        </p>
    </div>
  </div>`;
  });

  if (dataSetting.changePageType === "changePage") {
    contentContainer.innerHTML = output;
  } else if (dataSetting.changePageType === "viewMore") {
    contentContainer.innerHTML += output;
  }
}

export { renderPage, renderArticles, renderVideoList };
